import { useAuth } from "@/contexts/AuthContext";
import StudentCalendarView from "@/components/calendar/StudentCalendarView";
import ParentCalendarView from "@/components/calendar/ParentCalendarView";
import InstructorStudentCalendar from "@/components/calendar/InstructorStudentCalendar";
import { useParentData } from "@/hooks/useParentData";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

export function InlineCalendar({ role }: { role: string }) {
  const { user } = useAuth();
  if (!user) {
    return <Card><CardContent className="p-4 text-sm">Sign in to view your calendar.</CardContent></Card>;
  }
  if (role === "parent") return <ParentCalendarBlock />;
  return (
    <div className="rounded-lg border bg-card p-3">
      {role === "instructor" && <InstructorStudentCalendar />}
      {(role === "student" || role === "admin") && <StudentCalendarView studentUserId={user.id} />}
    </div>
  );
}

function ParentCalendarBlock() {
  const { children, loading } = useParentData();
  if (loading) {
    return <Card><CardContent className="p-4 flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Loading calendar…</CardContent></Card>;
  }
  return <div className="rounded-lg border bg-card p-3"><ParentCalendarView children={children} /></div>;
}
